var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"frameborder":"1","height":(_vm.height + "px"),"width":"100%","scrolling":"no","src":(_vm.VUE_APP_BASE_AUTH_MODULE + "/finance/income"),"allow":"clipboard-read; clipboard-write"}})])}
var staticRenderFns = []

export { render, staticRenderFns }